import { CKTooltip } from '@clearkit/react';
import debounce from 'lodash/debounce';

import ClearIcon from '~/components/icons/ClearIcon';
import SearchTextField from '~/components/SearchTextField';

const DEBOUNCE_INTERVAL = 700;
const MINIMUM_CHARACTERS = 3;

/*
 This component is for the header of Company and People list pages,
 whether in a Segment or not in a segment. It has a debounce (because searching is slow)
 and a minimum character limit (because indexes have a minimum length)
 */

const PeopleCompaniesSearchField = ({
  debounceInterval,
  onSearch,
  placeholder,
  searchQuery,
  ...props
}) => {
  const [showingTooltip, setShowingTooltip] = useState(false);
  const inputRef = useRef();

  const search = (value = '') => {
    const valid = value.length == 0 || value.length >= MINIMUM_CHARACTERS;
    setShowingTooltip(!valid);
    if (valid) {
      onSearch(value);
    }
  };

  const debouncedSearch = debounce(search, debounceInterval);

  const handleClear = () => {
    inputRef.current.value = '';
    search();
  };

  const handleKeyPress = ({ target: { value } }) => {
    if (event.key === 'Enter') {
      search(value);
    }
  };

  return (
    <div className="relative flex-shrink-0 ml-auto" style={{ minWidth: 280 }}>
      <SearchTextField
        inputRef={inputRef}
        fullWidth
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        defaultValue={searchQuery}
        endAdornment={
          searchQuery && (
            <ClearIcon
              className="mr-2 cursor-pointer"
              onClick={handleClear}
              width={16}
            />
          )
        }
        onSearch={(event) => debouncedSearch(event.target.value)}
        {...props}
      />
      {showingTooltip && (
        <CKTooltip
          tooltip={<p>Please type at least 3 characters to search</p>}
          arrowPlacement="top"
          unstable_portal={false}
          options={{
            placement: 'bottom',
            visible: true,
          }}>
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none" />
        </CKTooltip>
      )}
    </div>
  );
};

PeopleCompaniesSearchField.propTypes = {
  classes: PropTypes.object,
  debounceInterval: PropTypes.number,
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  searchQuery: PropTypes.string,
};

PeopleCompaniesSearchField.defaultProps = {
  debounceInterval: DEBOUNCE_INTERVAL,
};

export default PeopleCompaniesSearchField;
